import { QuestionReviewTaskQuestionDetailsSection } from '@exam-management/new-question-review-task-question-details';

export default function TaskManagementQuestionDetailsPage() {
  return <QuestionReviewTaskQuestionDetailsSection />;
}
